// extracted by mini-css-extract-plugin
export default {"root":"BJuf4"};